<div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
  <h2 *ngIf="isUpdateMode()" class="headline m-0" fxFlex="auto">
    {{ 'EDIT_JOB' | translate }}
  </h2>
  <h2 *ngIf="isCreateMode()" class="headline m-0" fxFlex="auto">
    {{ 'NEW_JOB' | translate }}
  </h2>

  <div
    *ngIf="isPremiumUser && isCreateMode()"
    fxLayout="row"
    fxLayoutGap="8px"
    class="mr-4">
    <span style="font-size: 16px; font-weight: 400">{{
      'SIMPLE_JOB_CREATION' | translate
    }}</span>
    <mat-slide-toggle
      [formControl]="simpleCreationCtrl"
      color="primary"
      (change)="onSimpleCreationToggleChanged($event)"></mat-slide-toggle>
  </div>

  <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>
</div>

<mat-divider class="-mx-6 text-border"></mat-divider>

<mat-dialog-content fxLayout="column">
  <div class="container">
    <div id="content">
      <div @fadeInUp id="main-content">
        <mat-horizontal-stepper #horizontalStepper [linear]="true">
          <ng-template matStepperIcon="key">
            <mat-icon>vpn_key</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="location">
            <mat-icon>location_on</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="date">
            <mat-icon> calendar_today </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="salary">
            <mat-icon> account_balance </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="optional">
            <mat-icon> list </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="customfield">
            <mat-icon> support_agent </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="users">
            <mat-icon> group </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="questions">
            <mat-icon> help_center </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="resource">
            <mat-icon> source </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="score">
            <mat-icon> score </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="preview">
            <mat-icon> preview </mat-icon>
          </ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon [icIcon]="icDoneAll"></mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon [icIcon]="icDoneAll"></mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon [icIcon]="icDoneAll"></mat-icon>
          </ng-template>

          <mat-step [stepControl]="keyFormGroup" label="Key" state="key">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'KEY' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>
            <form [formGroup]="keyFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>vpn_key</mat-icon>
                  <span>{{ 'KEY' | translate }}</span>
                </h3>
              </div>

              <div
                *ngIf="isCreateMode()"
                class="mt-4"
                fxLayout="row"
                fxLayoutAlign="start center">
                <div class="w-full" fxLayout="column">
                  <mat-form-field class="flex-auto" appearance="outline">
                    <mat-label>{{ 'SELECT_TEMPLATE' | translate }}</mat-label>
                    <input
                      [matAutocomplete]="autoTemplate"
                      [formControl]="templateInputCtrl"
                      type="text"
                      matInput />
                    <mat-autocomplete
                      #autoTemplate
                      (optionSelected)="onTemplateSelected($event.option.value)"
                      [displayWith]="templateDisplay">
                      <mat-option
                        *ngFor="let item of filteredTemplates | async"
                        [value]="item">
                        <!-- [value]="item.JTemplateID" -->
                        {{ item.TemplateTitle }}</mat-option
                      >
                    </mat-autocomplete>
                    <!-- <mat-select (selectionChange)="onTemplateSelected($event.value)" 
                      disableOptionCentering
                      panelClass="mat-select-custom-panel">
                      <mat-option [value]="item.JTemplateID" *ngFor="let item of jobTemplates">
                        {{ item.TemplateTitle }}
                      </mat-option>
                    </mat-select> -->
                    <mat-icon matPrefix>text_snippet</mat-icon>
                    <mat-hint>({{ 'SELECT_A_TEMPLATE' | translate }})</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div *ngIf="!isCreateMode()" class="py-1"></div>

              <div class="mt-2" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field fxFlex="auto" class="w-full">
                  <mat-label>{{ 'JOB_TITLE' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="jobTitle"
                    autocomplete="off"
                    [errorStateMatcher]="matcher"
                    required />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error *ngIf="keyFormGroup.get('jobTitle').hasError('required')">
                    {{ 'JOB_TITLE_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="example-chip-list">
                  <mat-label>{{ 'JOB_KEYWORD' | translate }}</mat-label>
                  <mat-chip-list #keywordChipList aria-label="Job Keyword selection">
                    <mat-chip
                      *ngFor="let item of keywords"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="removeKeyword(item)">
                      {{ item }}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                      #keywordInput
                      formControlName="jobKeyword"
                      [matAutocomplete]="autoKeyword"
                      [matChipInputFor]="keywordChipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addKeyword($event)" />
                  </mat-chip-list>
                  <mat-autocomplete
                    #autoKeyword="matAutocomplete"
                    (optionSelected)="selectedKeyword($event)">
                    <ng-container *ngFor="let item of JKeywords | async">
                      <mat-option
                        *ngIf="!keywords.includes(item.HotbookName)"
                        [value]="item.HotbookName">
                        {{ item.HotbookName }}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                  <mat-icon matPrefix>business_center</mat-icon>
                </mat-form-field>

                <div
                  fxLayout="row"
                  fxLayout.xs="column"
                  fxlayoutAlign="start start"
                  fxLayoutGap="20px">
                  <mat-form-field class="w-full" appearance="outline">
                    <mat-label>{{ 'BUSINESS_UNIT' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="getDepartments($event.value)"
                      formControlName="buisnessUnit"
                      disableOptionCentering
                      panelClass="mat-select-custom-panel"
                      [errorStateMatcher]="matcher"
                      required>
                      <mat-option
                        *ngFor="let item of buisnessUnitData"
                        [value]="item.id"
                        >{{ item.name }}</mat-option
                      >
                    </mat-select>
                    <mat-icon matPrefix>business</mat-icon>
                    <mat-error
                      *ngIf="keyFormGroup.get('buisnessUnit').hasError('required')">
                      {{ 'BUSINESS_UNIT_IS_REQUIRED' | translate }}
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="w-full" appearance="outline">
                    <mat-label>{{ 'DEPARTMENTS' | translate }}</mat-label>
                    <mat-select
                      formControlName="department"
                      disableOptionCentering
                      panelClass="mat-select-custom-panel"
                      [errorStateMatcher]="matcher"
                      required>
                      <mat-option
                        *ngFor="let item of departmentData"
                        [value]="item.deptid"
                        >{{ item.departmentName }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matPrefix>business</mat-icon>
                    <mat-error
                      *ngIf="keyFormGroup.get('department').hasError('required')">
                      {{ 'DEPARTMENT_IS_REQUIRED' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div
                  class="flex-auto html-editor mb-4 mt-3"
                  [ngClass]="{ hasErrorBorder: showJobDescriptionError }">
                  <p
                    class="ml-6 pt-4 subheading-2 font-medium"
                    [ngClass]="{ hasError: showJobDescriptionError }">
                    {{ 'JOB_DESCRIPTION' | translate }}
                    {{ 'AND' | translate }}
                    {{ 'REQUIRED_SKILL_EXPERIENCE' | translate }} *
                  </p>
                  <quill-editor
                    @fadeInUp
                    [styles]="{ flex: '1 1 auto', height: '280px' }"
                    formControlName="jobDescription"
                    required>
                  </quill-editor>
                </div>
                <mat-error *ngIf="showJobDescriptionError">
                  {{ 'JOB_DESCRIPTION_IS_REQUIRED' | translate }}
                </mat-error>

                <!-- 
                <div class="flex-auto html-editor mb-4 mt-3">
                  <p class="ml-6 pt-4 subheading-2 font-medium">
                    {{'REQUIRED_SKILL_EXPERIENCE' | translate}}
                  </p>
                  <quill-editor @fadeInUp [styles]="{ flex: '1 1 auto', height: '280px' }"
                    formControlName="requiredSkillExperience">
                  </quill-editor>
                </div> -->

                <div class="flex-auto html-editor mb-4 mt-3">
                  <p class="ml-6 pt-4 subheading-2 font-medium">
                    {{ 'JOB_BENEFITS_PER_DIEM_AND_COMPENSATION_PACKAGES' | translate }}
                  </p>
                  <quill-editor
                    @fadeInUp
                    [styles]="{ flex: '1 1 auto', height: '280px' }"
                    formControlName="jobBenefit">
                  </quill-editor>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="locationFormGroup" label="Location" state="location">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'LOCATION' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>

            <form [formGroup]="locationFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>location_on</mat-icon>
                  <span>{{ 'LOCATION' | translate }}</span>
                </h3>
              </div>

              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <!-- locations selection -->
                <mat-form-field *ngIf="isHourlyApplyAvailable()" appearance="outline">
                  <mat-label>{{ 'LOCATIONS' | translate }}</mat-label>
                  <mat-select formControlName="locations" multiple>
                    <mat-select-trigger>
                      {{
                        (locationFormGroup.controls['locations'].value?.length || 0) >= 1
                          ? getDepartmentName(
                              locationFormGroup.controls['locations'].value[0]
                            )
                          : ''
                      }}
                      <span
                        *ngIf="
                          (locationFormGroup.controls['locations'].value?.length || 0) > 1
                        "
                        class="location-additional-selection">
                        (+{{
                          (locationFormGroup.controls['locations'].value?.length || 0) - 1
                        }}
                        {{
                          locationFormGroup.controls['locations'].value?.length === 2
                            ? ('OTHER' | translate)
                            : ('OTHERS' | translate)
                        }})
                      </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let item of departmentData" [value]="item.deptid">
                      {{ item.departmentName }}&#40;{{ locationDisplay(item) }}&#41;
                    </mat-option>
                  </mat-select>
                  <mat-hint>{{ 'ADD_MULTIPLE_LOCATIONS' | translate }}</mat-hint>
                </mat-form-field>

                <mat-label (click)="toggleAddress()" class="cursor-pointer"
                  >Company Address</mat-label
                >
                <mat-form-field class="w-full">
                  <mat-label>{{ 'CITY_TOWN' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="locationCity"
                    [errorStateMatcher]="matcher"
                    autocomplete="off"
                    required />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationCity').hasError('required')">
                    {{ 'CITY_TOWN_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'COUNTRY' | translate }} *</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="locationCountry"
                    [matAutocomplete]="autoCountry"
                    [errorStateMatcher]="matcher"
                    autocomplete="off" />
                  <mat-autocomplete
                    #autoCountry="matAutocomplete"
                    (optionSelected)="getStates($event.option.value)"
                    (closed)="onCountryOptionPanelClosed()">
                    <mat-option
                      *ngFor="let countrie of filteredCountriesData"
                      [value]="countrie.name">
                      {{ countrie.name }}
                      <div
                        *ngIf="countrie.iso == 'USA'"
                        style="background: lightgray; height: 2px"></div>
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matPrefix>location_on</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationCountry').hasError('required')">
                    {{ 'COUNTRY_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'STATE' | translate }} *</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="locationState"
                    [matAutocomplete]="autoState"
                    [errorStateMatcher]="matcher"
                    autocomplete="off" />
                  <mat-autocomplete
                    #autoState="matAutocomplete"
                    (closed)="onStateOptionPanelClosed()">
                    <mat-option
                      *ngFor="let state of filteredStateData"
                      [value]="state.name">
                      {{ state.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matPrefix>location_on</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationState').hasError('required')">
                    {{ 'STATE_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>{{ 'ZIP_POSTAL_CODE' | translate }}</mat-label>
                  <input
                    formControlName="locationZip"
                    [errorStateMatcher]="matcher"
                    autocomplete="off"
                    required
                    matInput />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error
                    *ngIf="locationFormGroup.get('locationZip').hasError('required')">
                    {{ 'ZIP_POSTAL_CODE_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>{{ 'ADDITIONAL_LOCATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="locationAdditional"
                    autocomplete="off" />
                  <mat-icon matPrefix>business_center</mat-icon>
                </mat-form-field>
              </div>
            </form>
          </mat-step>

          <!-- <mat-step [stepControl]="dateFormGroup" label="Date" state="date" optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
              </ng-template>
            </div>

            <form [formGroup]="dateFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>calendar_today</mat-icon> <span>Date</span>
                </h3>
              </div>
              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <div fxLayout="row" fxLayout.xs="column" fxlayoutAlign="start start" fxLayoutGap="20px">
                  <mat-form-field class="w-full" appearance="outline">
                    <mat-label>Internal Career Hosting Expiration Date</mat-label>
                    <mat-select formControlName="internalCarrerHosting" 
                      disableOptionCentering
                      panelClass="mat-select-custom-panel"
                      [errorStateMatcher]="matcher"
                      required>
                      <mat-option *ngFor="let item of jobExpirationDateData" [value]="item.value">
                        {{item.name}}</mat-option>
                    </mat-select>
                    <mat-hint>Internal job posting will deactivate on this date.</mat-hint>
                    <mat-icon matPrefix>meeting_room</mat-icon>
                  </mat-form-field>
                  <mat-form-field class="w-full" appearance="outline">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="chooseDatePickerRef"
                      (click)="chooseDatePickerRef.open()"
                      (focus)="chooseDatePickerRef.open()"
                      formControlName="chooseDate" />
                    <mat-datepicker-toggle matSuffix [for]="chooseDatePickerRef"></mat-datepicker-toggle>
                    <mat-datepicker #chooseDatePickerRef></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>Starting/potential date</mat-label>
                  <input matInput [matDatepicker]="startingDatePickerRef"
                    (click)="startingDatePickerRef.open()" 
                    (focus)="startingDatePickerRef.open()" 
                    formControlName="startingDate" />
                  <mat-datepicker-toggle matSuffix [for]="startingDatePickerRef"></mat-datepicker-toggle>
                  <mat-datepicker #startingDatePickerRef></mat-datepicker>
                </mat-form-field>
              </div>
            </form>
          </mat-step> -->

          <mat-step
            [stepControl]="salaryFormGroup"
            label="Salary"
            state="salary"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'SALARY' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>
            <form [formGroup]="salaryFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>account_balance</mat-icon>
                  <span>{{ 'SALARY' | translate }}</span>
                </h3>
              </div>

              <mat-radio-group
                class="mt-4"
                fxLayout="row"
                fxLayoutGap="24px"
                formControlName="salary"
                (change)="onSalaryChanged($event.value)">
                <mat-radio-button color="primary" value="1">{{
                  'CUSTOM_SALARY' | translate
                }}</mat-radio-button>
                <mat-radio-button color="primary" value="0">{{
                  'COMPETITIVE' | translate
                }}</mat-radio-button>
              </mat-radio-group>

              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label
                    >{{ 'MIN' | translate
                    }}<span *ngIf="salaryFormGroup.get('salary').value === '1'"
                      >&nbsp;*</span
                    ></mat-label
                  >
                  <input
                    type="number"
                    formControlName="min"
                    [errorStateMatcher]="matcher"
                    matInput />
                  <mat-icon matPrefix>meeting_room</mat-icon>
                  <mat-error *ngIf="salaryFormGroup.get('min').hasError('required')">
                    {{ 'MIN_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'MAX' | translate }}</mat-label>
                  <input
                    type="number"
                    formControlName="max"
                    [errorStateMatcher]="matcher"
                    matInput />
                  <mat-icon matPrefix>meeting_room</mat-icon>
                  <mat-error *ngIf="salaryFormGroup.get('max').hasError('wrongSalary')">
                    {{ 'MAX_SHOULD_BE_BIGGER_THAN_MIN' | translate }}
                  </mat-error>
                  <!-- <mat-error *ngIf="salaryFormGroup.get('salaryMax').hasError('required')">
                    {{'MAX_IS_REQUIRED' | translate}}
                  </mat-error> -->
                </mat-form-field>
              </div>

              <mat-form-field class="flex-auto w-full" appearance="outline">
                <mat-label>{{ 'CURRENCY' | translate }}</mat-label>
                <mat-select
                  formControlName="currency"
                  disableOptionCentering
                  panelClass="mat-select-custom-panel"
                  [errorStateMatcher]="matcher"
                  required>
                  <mat-option
                    *ngFor="let item of jobCurrencyData"
                    [value]="item.CurrencyISO">
                    {{ item.CurrencyName }}</mat-option
                  >
                </mat-select>
                <mat-icon matPrefix>money</mat-icon>
                <mat-error *ngIf="salaryFormGroup.get('currency').hasError('required')">
                  {{ 'CURRENCY_IS_REQUIRED' | translate }}
                </mat-error>
              </mat-form-field>

              <mat-label class="ml-4" style="color: gray">{{
                'SALARY_TYPE' | translate
              }}</mat-label>
              <div
                class="flex-auto mt-2 mb-4"
                fxlayoutAlign="start start"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayout.sm="column"
                fxLayoutGap="20px">
                <div
                  fxLayout="row"
                  fxLayoutAlign="space-around center"
                  class="w-full mb-2 salary-type">
                  <mat-button-toggle-group
                    id="overall-rating"
                    class="w-full"
                    name="fontStyle"
                    aria-label="Font Style"
                    formControlName="type">
                    <span
                      class="toggle-button w-full btn-border"
                      *ngFor="let item of salTypeData">
                      <mat-button-toggle
                        [value]="item.RefValue"
                        class="w-full"
                        fxLayoutAlign="center center">
                        <span class="toogle-text">{{ item.RefName }}</span>
                      </mat-button-toggle>
                    </span>
                  </mat-button-toggle-group>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step
            [stepControl]="optionalFormGroup"
            label="Additional Options"
            state="optional"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'ADDITIONAL_OPTIONS' | translate }}">
                  &nbsp;&nbsp;&nbsp;
                </div>
              </ng-template>
            </div>
            <form [formGroup]="optionalFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>list</mat-icon>
                  <span>{{ 'ADDITIONAL_OPTIONS' | translate }}</span>
                </h3>
              </div>

              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'JOB_CATEGORY' | translate }}</mat-label>
                  <mat-select
                    (selectionChange)="getSubcategories($event.value)"
                    formControlName="jobCateogary"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher">
                    <mat-option
                      *ngFor="let item of jobCategoryData"
                      [value]="item.cat_id">
                      {{ item.catname }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>card_travel</mat-icon>
                  <!-- <mat-error *ngIf="optionalFormGroup.get('jobCateogary').hasError('required')">
                    {{'JOB_CATEGORY_IS_REQUIRED' | translate}}
                  </mat-error> -->
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'SUB_CATEGORY' | translate }}</mat-label>
                  <mat-select
                    formControlName="subCategory"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher">
                    <mat-option
                      *ngFor="let item of jobSubCategoryData"
                      [value]="item.sub_id">
                      {{ item.subcatname }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>card_travel</mat-icon>
                  <!-- <mat-error *ngIf="optionalFormGroup.get('subCategory').hasError('required')">
                    {{'SUB_CATEGORY_IS_REQUIRED' | translate}}
                  </mat-error> -->
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'EEO_JOB_CATEGORY' | translate }}</mat-label>
                  <mat-select
                    formControlName="eeoJobCateogray"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher">
                    <mat-option
                      *ngFor="let eeojob of eeoJobcategoryData"
                      [value]="eeojob.eeoc_cat_id">
                      {{ eeojob.category }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>work</mat-icon>
                  <!-- <mat-error *ngIf="optionalFormGroup.get('eeoJobCateogray').hasError('required')">
                    {{'EEO_JOB_CATEGORY_IS_REQUIRED' | translate}}
                  </mat-error> -->
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'STATUS' | translate }}</mat-label>
                  <mat-select
                    formControlName="status"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher"
                    required>
                    <mat-option value="1">{{ 'ACTIVE' | translate }}</mat-option>
                    <mat-option value="3">{{ 'INACTIVE' | translate }}</mat-option>
                    <mat-option value="4">{{ 'POTENTIAL' | translate }}</mat-option>
                    <mat-option value="5">{{ 'CLOSED' | translate }}</mat-option>
                    <mat-option value="6">{{ 'APPROVED' | translate }}</mat-option>
                  </mat-select>
                  <mat-icon matPrefix>work</mat-icon>
                  <mat-error *ngIf="optionalFormGroup.get('status').hasError('required')">
                    {{ 'STATUS_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'JOB_TYPE' | translate }}</mat-label>
                  <mat-select
                    formControlName="jobType"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher"
                    required>
                    <mat-option
                      *ngFor="let jobtype of jobtypeData"
                      [value]="jobtype.jobTypedesc">
                      {{ jobtype.jobTypedesc }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matPrefix>work</mat-icon>
                  <mat-error
                    *ngIf="optionalFormGroup.get('jobType').hasError('required')">
                    {{ 'JOB_TYPE_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>                

                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'START_DATE' | translate }}</mat-label>
                  <input 
                    matInput 
                    [matDatepicker]="startingDatePickerRef"
                    (click)="startingDatePickerRef.open()" 
                    (focus)="startingDatePickerRef.open()" 
                    formControlName="startingDate" />
                    <mat-icon matPrefix>date_range</mat-icon>
                  <mat-datepicker #startingDatePickerRef></mat-datepicker>
                </mat-form-field>


                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'NUMBER_OF_OPENINGS' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="noOfOpening"
                    [errorStateMatcher]="matcher"
                    required />
                  <mat-icon matPrefix>business_center</mat-icon>
                  <mat-error
                    *ngIf="optionalFormGroup.get('noOfOpening').hasError('required')">
                    {{ 'NUMBER_OF_OPENINGS_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>
                <div
                  class="flex-auto mb-4 mt-4"
                  fxlayoutAlign="start start"
                  fxLayout="row"
                  fxLayout.xs="column"
                  fxLayout.sm="column"
                  fxLayoutGap="20px">
                  <mat-label>{{ 'HOURS_SHIFT' | translate }}</mat-label>
                  <div gdColumns="1fr 1fr 1fr 1fr" class="w-full" gdGap="20px">
                    <div *ngFor="let shift of shiftData; let i = index">
                      <mat-checkbox
                        color="primary"
                        [formControlName]="shift.ShiftValue"
                        [checked]="shift.aflag">
                        {{ shift.ShiftName }}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div
                  class="flex-auto mb-4 mt-4"
                  fxlayoutAlign="start start"
                  fxLayout="row"
                  fxLayout.xs="column"
                  fxLayout.sm="column"
                  fxLayoutGap="20px">
                  <mat-label>{{ 'JOB_PRIORITY' | translate }}</mat-label>
                  <mat-radio-group formControlName="jobPriority">
                    <mat-radio-button color="primary" class="mr-2" value="0">{{
                      'LOW' | translate
                    }}</mat-radio-button>
                    <mat-radio-button color="primary" class="mr-2" value="1">{{
                      'NORMAL' | translate
                    }}</mat-radio-button>
                    <mat-radio-button color="primary" class="mr-2" value="2">{{
                      'HIGH' | translate
                    }}</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div
                  class="flex-auto mb-4 mt-4"
                  fxlayoutAlign="start start"
                  fxLayout="row"
                  fxLayout.xs="column"
                  fxLayout.sm="column"
                  fxLayoutGap="20px">
                  <mat-label>{{ 'CONFIDENTIAL' | translate }}</mat-label>
                  <mat-radio-group
                    formControlName="jobConfidential"
                    fxLayout.xs="column"
                    fxLayoutAlign="start start">
                    <mat-radio-button
                      color="primary"
                      class="mr-2"
                      *ngFor="let item of jobConfidentialData"
                      [value]="item.value">
                      {{ item.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'LANGUAGE' | translate }}</mat-label>
                  <mat-select formControlName="language">
                    <mat-option
                      *ngFor="let language of languageData"
                      [value]="language.LangID">
                      {{ language.LanguageName }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matPrefix>language</mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'JOB_LEVEL' | translate }}</mat-label>
                  <mat-select formControlName="jobLevel">
                    <mat-option
                      *ngFor="let joblevel of joblevelData"
                      [value]="joblevel.LevelValue">
                      {{ joblevel.LevelName }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>work</mat-icon>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="outline">
                  <mat-label>{{ 'CUSTOM_JOB_ID' | translate }}</mat-label>
                  <input matInput formControlName="customJobId" />
                  <mat-icon matPrefix>business_center</mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'YEAR_OF_EXPERIENCE' | translate }}</mat-label>
                  <mat-select formControlName="yearOfExperience">
                    <mat-option
                      *ngFor="let yearofexperienceitem of yearOfExperienceData"
                      [value]="yearofexperienceitem.YearExpValue">
                      {{ yearofexperienceitem.YearExp }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>location_on</mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'LEVEL_OF_EDUCATION' | translate }}</mat-label>
                  <mat-select formControlName="levelOfEducation">
                    <mat-option
                      *ngFor="let education of educationLevelData"
                      [value]="education.DegreeOrder">
                      {{ education.DegreeName }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>maps_home_work</mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'JOB_DURATION' | translate }}</mat-label>
                  <mat-select formControlName="jobDuration">
                    <mat-option
                      *ngFor="let duration of jobDurationData"
                      [value]="duration.value">
                      {{ duration.name }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>work</mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'TRAVEL_FREQUENCY' | translate }}</mat-label>
                  <mat-select formControlName="travelFrequence">
                    <mat-option
                      *ngFor="let item of jobTravelFrequencyData"
                      [value]="item.value">
                      {{ item.name }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matPrefix>card_travel</mat-icon>
                </mat-form-field>
                <mat-form-field class="w-full">
                  <mat-label>{{ 'INTERNAL_COMMENT_AND_NOTES' | translate }}</mat-label>
                  <textarea matInput formControlName="internalCommentNotes"></textarea>
                </mat-form-field>
              </div>
            </form>
          </mat-step>

          <mat-step
            *ngIf="!isSimpleCreationEnabled"
            [stepControl]="customFormGroup"
            label="Custom Fields"
            state="support_agent"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'CUSTOM_FIELDS' | translate }}">
                  &nbsp;&nbsp;&nbsp;
                </div>
              </ng-template>
            </div>

            <form [formGroup]="customFormGroup" class="w-full" autocomplete="off">
              <div class="hire-custom-field" fxLayout="column" fxLayoutGap="8px">
                <div fxLayout="row" fxlayoutAlign="center center">
                  <h3>
                    <mat-icon>support_agent</mat-icon>
                    <span>{{ 'CUSTOM_FIELDS' | translate }}</span>
                  </h3>
                </div>

                <div fxLayout="column" fxLayoutGap="8px">
                  <div class="flex-auto m-4" *ngIf="customFields.length == 0">
                    <h3>
                      {{ 'THERE_NO_CUSTOM_FIELD_NEED_TO_CREATE_TO_ADD_JOB' | translate }}
                    </h3>
                    <h3>
                      {{
                        'YOU_CREATE_CUSTOM_FIELD_SETTING_RECRUITING_PREFERENCE_CUSTOM_FIELDS'
                          | translate
                      }}
                    </h3>
                    <h3>{{ 'PLEASE_CLICK_BUTTON_BELOW' | translate }}.</h3>
                    <br />
                  </div>
                </div>

                <div class="flex-auto mb-4">
                  <div *ngFor="let item of customFields; let i = index">
                    <div *ngIf="item.customFieldType === 0">
                      <p class="mb-2">{{ i + 1 }}.&nbsp;{{ item.customFieldName }}</p>
                      <mat-form-field class="w-full" appearance="outline">
                        <mat-label>{{ 'VALUE' | translate }}</mat-label>
                        <input
                          [formControlName]="item.customFieldID"
                          [required]="item.customFieldRequired === 1"
                          matInput
                          [errorStateMatcher]="matcher" />
                        <mat-error
                          *ngIf="
                            customFormGroup.controls[item.customFieldID].errors?.required
                          ">
                          {{ item.customFieldName }}
                          {{ 'IS_REQUIRED' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div *ngIf="item.customFieldType === 1">
                      <p class="mb-2">{{ i + 1 }}.&nbsp;{{ item.customFieldName }}</p>
                      <mat-form-field class="w-full max-w-md" appearance="outline">
                        <mat-label>Select an option</mat-label>
                        <mat-select
                          [formControlName]="item.customFieldID"
                          [required]="item.customFieldRequired === 1"
                          disableOptionCentering
                          panelClass="mat-select-custom-panel"
                          [errorStateMatcher]="matcher">
                          <mat-option
                            *ngFor="let value of item.selectFromValue"
                            [value]="value"
                            >{{ value }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="
                            customFormGroup.controls[item.customFieldID].errors?.required
                          ">
                          {{ item.customFieldName }}
                          {{ 'IS_REQUIRED' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div *ngIf="item.customFieldType === 2" class="mb-4">
                      <p class="mb-2">{{ i + 1 }}.&nbsp;{{ item.customFieldName }}</p>
                      <div
                        [formArrayName]="item.customFieldID"
                        fxLayout="column"
                        fxLayoutAlign="start start"
                        fxLayoutGap="4px">
                        <mat-checkbox
                          *ngFor="let value of item.selectFromValue; let i = index"
                          [formControlName]="i"
                          class="ml-2"
                          color="primary"
                          >{{ value }}</mat-checkbox
                        >
                      </div>
                      <mat-error
                        *ngIf="
                          customFormGroup.controls[item.customFieldID].errors?.required
                        "
                        class="error-label ml-2 mt-1">
                        {{ item.customFieldName }}
                        {{ 'IS_REQUIRED' | translate }}
                      </mat-error>
                    </div>

                    <div *ngIf="item.customFieldType === 3" class="mb-4">
                      <p class="mb-2">{{ i + 1 }}.&nbsp;{{ item.customFieldName }}</p>
                      <mat-radio-group
                        class="ml-2"
                        color="primary"
                        [formControlName]="item.customFieldID">
                        <mat-radio-button
                          class="mr-8"
                          *ngFor="let value of item.selectFromValue"
                          [value]="value"
                          >{{ value }}</mat-radio-button
                        >
                      </mat-radio-group>
                      <mat-error
                        *ngIf="
                          customFormGroup.controls[item.customFieldID].errors?.required
                        "
                        class="error-label ml-2 mt-1">
                        {{ item.customFieldName }}
                        {{ 'IS_REQUIRED' | translate }}
                      </mat-error>
                    </div>
                  </div>

                  <button (click)="createCustomField()" color="primary" mat-raised-button>
                    {{ 'CREATE_NEW_CUSTOMFIELD' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step
            *ngIf="!isSimpleCreationEnabled"
            [stepControl]="userFormGroup"
            label="Users"
            state="users"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'USERS' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>

            <form [formGroup]="userFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>group</mat-icon>
                  <span>{{ 'USERS' | translate }}</span>
                </h3>
              </div>
              <div class="mt-4" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>Hiring Manager(s)</mat-label>
                  <mat-chip-list #hiringManagerList>
                    <mat-chip
                      *ngFor="let hiringManager of selectedHiringMangers"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="hiringManagerRemoved(hiringManager)">
                      {{ hiringManager.userName }}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                      placeholder="Add Hiring Manager"
                      #hiringManagerInput
                      formControlName="hiringManager"
                      [matAutocomplete]="hiringManagerAutocomplete"
                      [matChipInputFor]="hiringManagerList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addHiringManager($event)" />
                  </mat-chip-list>
                  <mat-autocomplete
                    #hiringManagerAutocomplete="matAutocomplete"
                    (optionSelected)="hiringManagerSelected($event)">
                    <ng-container *ngFor="let filtered of filteredHiringManagers | async">
                      <mat-option
                        *ngIf="!isHiringManagerSelected(filtered)"
                        [value]="filtered.uid">
                        {{ filtered.userName }}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                  <mat-icon class="mr-2" matPrefix>group</mat-icon>
                </mat-form-field>

                <!-- Commnted by Cai on 25 Feb, 2023 -->
                <!-- <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>Recruiter(s)</mat-label>
                  <mat-chip-list #chipList2>
                    <mat-chip 
                      *ngFor="let recruiter of selectedRecruiters" 
                      [selectable]="selectable2"
                      [removable]="removable2" 
                      (removed)="recruiterRemoved(recruiter)">
                      {{ recruiter.userName }}
                      <mat-icon matChipRemove *ngIf="removable2">cancel</mat-icon>
                    </mat-chip>
                    <input 
                      placeholder="Add Recruiter" 
                      #recruiterInput 
                      formControlName="recruiter" 
                      [matAutocomplete]="recruiterAutocomplete"
                      [matChipInputFor]="chipList2" 
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addRecruiter($event)"/>
                  </mat-chip-list>
                  <mat-autocomplete 
                    #recruiterAutocomplete="matAutocomplete" 
                    (optionSelected)="recruiterSelected($event)">
                    <ng-container *ngFor="let filtered of filteredRecruiters | async">
                      <mat-option 
                        *ngIf="!isRecruiterSelected(filtered)" 
                        [value]="filtered.uid">
                        {{ filtered.userName }}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                  <mat-icon class="mr-2" matPrefix>groups</mat-icon>
                </mat-form-field> -->

                <mat-form-field class="flex-auto w-full" appearance="outline">
                  <mat-label>{{ 'JOB_OWNER_ADMIN' | translate }}</mat-label>
                  <mat-select
                    formControlName="owner"
                    disableOptionCentering
                    panelClass="mat-select-custom-panel"
                    [errorStateMatcher]="matcher"
                    required>
                    <mat-option *ngFor="let item of powerUserData" [value]="item.uid">
                      {{ item.firstname + ' ' + item.lastname }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matPrefix>person</mat-icon>
                  <mat-error *ngIf="userFormGroup.get('owner').hasError('required')">
                    {{ 'OWNER_IS_REQUIRED' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </mat-step>

          <mat-step
            *ngIf="!isSimpleCreationEnabled"
            [stepControl]="questionFormGroup"
            label="Questions"
            state="questions"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'QUESTIONS' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>

            <div fxLayout="row" fxlayoutAlign="center center">
              <h3>
                <mat-icon>help_center</mat-icon>
                <span>{{ 'QUESTIONS' | translate }}</span>
              </h3>
            </div>
            <div class="mt-4 w-full overflow-auto" fxLayout="column" fxLayoutGap="8px">
              <div class="interview-group" *ngFor="let group of jobQuestionGroups">
                <span class="example-list-section">
                  <mat-checkbox
                    color="primary"
                    [checked]="group.isAllSelected"
                    [indeterminate]="isQuestionSelectedInGroup(group)"
                    (change)="onQuestionGroupSelected($event.checked, group)">
                    {{ group.qcatname }}
                  </mat-checkbox>
                </span>
                <span class="example-list-section">
                  <ul>
                    <li class="ml-4" *ngFor="let question of group.questions">
                      <mat-checkbox
                        color="primary"
                        [(ngModel)]="question.isSelected"
                        (ngModelChange)="onQuestionSelected(group)"
                        [ngModelOptions]="{ standalone: true }">
                        {{ question.Question }}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
              </div>
              <div class="my-4">
                <button color="primary" mat-raised-button (click)="addNewQuestion()">
                  {{ 'ADD_NEW_QUESTION' | translate }}
                </button>
              </div>
            </div>
          </mat-step>

          <mat-step
            *ngIf="!isSimpleCreationEnabled"
            [stepControl]="resourceFormGroup"
            label="Resource"
            state="resource">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'RESOURCE' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>

            <form [formGroup]="resourceFormGroup" fxLayout="column" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>source</mat-icon>
                  <span>{{ 'RESOURCE' | translate }}</span>
                </h3>
              </div>

              <div
                fxFlex="100%"
                gdColumns="1fr 1fr 1fr"
                gdColumns.sm="1fr 1fr"
                gdColumns.xs="1fr"
                gdGap="10px"
                style="padding: 10px">
                <div
                  class="mb-4"
                  *ngFor="let order of ordersFormArray.controls; let i = index">
                  <div class="alert-title" fxLayout="column">
                    <div id="ck-button">
                      <label formArrayName="resources">
                        <input type="checkbox" [formControlName]="i" />
                        <span
                          style="height: 150px; display: block !important; padding: 10px">
                          <img
                            [src]="resourcesData[i].SourceNameImg"
                            alt=""
                            style="object-fit: contain"
                            height="40px"
                            width="180px" />
                          <h3 style="text-align: left; margin-top: 10px">
                            {{ resourcesData[i].mysitename }}
                          </h3>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </mat-step>

          <mat-step
            *ngIf="!isSimpleCreationEnabled"
            [stepControl]="scorecardFormGroup"
            label="Scorecard"
            state="score"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'SCORECARD' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>
            <form [formGroup]="scorecardFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>score</mat-icon>
                  <span>{{ 'SCORECARD' | translate }}</span>
                </h3>
              </div>
              <ng-template matStepLabel> Scorecard </ng-template>
              <mat-form-field class="flex-auto w-full" appearance="outline">
                <mat-label>{{ 'AVAILABLE_SCORECARDS' | translate }}</mat-label>
                <mat-select
                  formControlName="scorecard"
                  disableOptionCentering
                  panelClass="mat-select-custom-panel">
                  <mat-option
                    *ngFor="let item of jobAvailableScorecardData"
                    [value]="item.SGID">
                    {{ item.GroupName }}
                  </mat-option>
                </mat-select>
                <mat-hint
                  >{{
                    'CHOOSE_WHICH_SCORECARD_TO_USE_WITH_THIS_POSITION' | translate
                  }}.</mat-hint
                >
                <mat-icon matPrefix>work</mat-icon>
              </mat-form-field>
            </form>
          </mat-step>

          <!-- 
            to add save as a template in a short steps
            *ngIf="!isSimpleCreationEnabled" -->
          <mat-step
            [stepControl]="templateFormGroup"
            label="Template"
            state="template"
            optional="false">
            <div fxLayout="row">
              <ng-template matStepLabel fxlayoutAlign="center center">
                <div matTooltip="{{ 'TEMPLATE' | translate }}">&nbsp;&nbsp;&nbsp;</div>
              </ng-template>
            </div>
            <form [formGroup]="templateFormGroup" autocomplete="off">
              <div fxLayout="row" fxlayoutAlign="center center">
                <h3>
                  <mat-icon>text_snippet</mat-icon>
                  <span>{{ 'SAVE_AS_TEMPLATE' | translate }}</span>
                </h3>
              </div>
              <ng-template matStepLabel> Template </ng-template>
              <mat-form-field class="flex-auto w-full" appearance="outline">
                <mat-label>Template Title</mat-label>
                <input matInput formControlName="templateTitle" autocomplete="off" />
              </mat-form-field>
            </form>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    *ngIf="
      (horizontalStepper.selectedIndex == 9 && !isSimpleCreationEnabled) ||
      (horizontalStepper.selectedIndex == 4 && isSimpleCreationEnabled)
    "
    [disabled]="!isSaveEnabled()"
    (click)="openPreviewDialog()"
    style="margin-right: auto">
    {{ 'PREVIEW' | translate }}
  </button>

  <button
    *ngIf="horizontalStepper.selectedIndex == 0"
    mat-button
    type="button"
    class="btn-close"
    (click)="horizontalStepper.reset()">
    {{ 'RESET' | translate }}
  </button>
  <button
    *ngIf="horizontalStepper.selectedIndex > 0"
    mat-button
    type="button"
    class="btn-close"
    (click)="horizontalStepper.previous()">
    {{ 'PREVIOUS' | translate }}
  </button>

  <button
    *ngIf="
      (horizontalStepper.selectedIndex < 9 && !isSimpleCreationEnabled) ||
      (horizontalStepper.selectedIndex < 4 && isSimpleCreationEnabled)
    "
    class="btn-action"
    (click)="next()"
    mat-button
    type="submit">
    {{ 'NEXT' | translate }}
  </button>

  <button
    *ngIf="
      (horizontalStepper.selectedIndex == 9 && !isSimpleCreationEnabled) ||
      (horizontalStepper.selectedIndex == 4 && isSimpleCreationEnabled)
    "
    class="btn-action"
    [disabled]="!isSaveEnabled()"
    (click)="save()"
    mat-raised-button
    type="submit">
    {{ (isCreateMode() ? 'CREATE_JOB' : 'UPDATE_JOB') | translate }}
  </button>

  <!-- <button *ngIf="isUpdateMode() && horizontalStepper.selectedIndex < 9" class="btn-action" (click)="next()" mat-button
    type="submit">
    {{'NEXT' | translate}}
  </button> -->
  <!-- <button *ngIf="isUpdateMode() && horizontalStepper.selectedIndex == 9" class="btn-action" (click)="save()" mat-button
    type="submit">
    {{'UPDATE_JOB' | translate}}
  </button> -->
</mat-dialog-actions>
